/*
 * Generated from docs/design-handoff/tossker-redesign/assets/icons/*.svg
 * (the vendored Lucide set, 24px grid, 2px stroke). Do not hand-edit — the
 * inner markup of each source SVG (everything between <svg ...> and </svg>)
 * is copied verbatim, keeping the vendored stroke-width, stroke-linecap and
 * stroke-linejoin. To add or update an icon, replace the source file in
 * that directory and regenerate this file the same way.
 */
export const ICONS = {
  'archive': `<rect width="20" height="5" x="2" y="3" rx="1"></rect>
  <path d="M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8"></path>
  <path d="M10 12h4"></path>`,
  'arrow-right': `<path d="M5 12h14"></path>
  <path d="m12 5 7 7-7 7"></path>`,
  'bell': `<path d="M10.268 21a2 2 0 0 0 3.464 0"></path>
  <path d="M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326"></path>`,
  'building-2': `<path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"></path>
  <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"></path>
  <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"></path>
  <path d="M10 6h4"></path>
  <path d="M10 10h4"></path>
  <path d="M10 14h4"></path>
  <path d="M10 18h4"></path>`,
  'check-check': `<path d="M18 6 7 17l-5-5"></path>
  <path d="m22 10-7.5 7.5L13 16"></path>`,
  'check': `<path d="M20 6 9 17l-5-5"></path>`,
  'chevron-down': `<path d="m6 9 6 6 6-6"></path>`,
  'chevron-right': `<path d="m9 18 6-6-6-6"></path>`,
  'circle-check': `<circle cx="12" cy="12" r="10"></circle>
  <path d="m9 12 2 2 4-4"></path>`,
  'clock': `<path d="M12 6v6l4 2"></path>
  <circle cx="12" cy="12" r="10"></circle>`,
  'filter': `<path d="M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z"></path>`,
  'headphones': `<path d="M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3"></path>`,
  'inbox': `<polyline points="22 12 16 12 14 15 10 15 8 12 2 12"></polyline>
  <path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path>`,
  'info': `<circle cx="12" cy="12" r="10"></circle>
  <path d="M12 16v-4"></path>
  <path d="M12 8h.01"></path>`,
  'link-2': `<path d="M9 17H7A5 5 0 0 1 7 7h2"></path>
  <path d="M15 7h2a5 5 0 1 1 0 10h-2"></path>
  <line x1="8" x2="16" y1="12" y2="12"></line>`,
  'list-checks': `<path d="M13 5h8"></path>
  <path d="M13 12h8"></path>
  <path d="M13 19h8"></path>
  <path d="m3 17 2 2 4-4"></path>
  <path d="m3 7 2 2 4-4"></path>`,
  'lock': `<rect width="18" height="11" x="3" y="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path>`,
  'log-out': `<path d="m16 17 5-5-5-5"></path>
  <path d="M21 12H9"></path>
  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>`,
  'message-circle': `<path d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719"></path>`,
  'message-square': `<path d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z"></path>`,
  'more-horizontal': `<circle cx="12" cy="12" r="1"></circle>
  <circle cx="19" cy="12" r="1"></circle>
  <circle cx="5" cy="12" r="1"></circle>`,
  'panel-left': `<rect width="18" height="18" x="3" y="3" rx="2"></rect>
  <path d="M9 3v18"></path>`,
  'paperclip': `<path d="m16 6-8.414 8.586a2 2 0 0 0 2.829 2.829l8.414-8.586a4 4 0 1 0-5.657-5.657l-8.379 8.551a6 6 0 1 0 8.485 8.485l8.379-8.551"></path>`,
  'pause': `<rect x="14" y="3" width="5" height="18" rx="1"></rect>
  <rect x="5" y="3" width="5" height="18" rx="1"></rect>`,
  'pencil': `<path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"></path>
  <path d="m15 5 4 4"></path>`,
  'phone-incoming': `<path d="M16 2v6h6"></path>
  <path d="m22 2-6 6"></path>
  <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path>`,
  'phone-missed': `<path d="m16 2 6 6"></path>
  <path d="m22 2-6 6"></path>
  <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path>`,
  'phone-outgoing': `<path d="m16 8 6-6"></path>
  <path d="M22 8V2h-6"></path>
  <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path>`,
  'phone': `<path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path>`,
  'plus': `<path d="M5 12h14"></path>
  <path d="M12 5v14"></path>`,
  'refresh-cw': `<path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"></path>
  <path d="M21 3v5h-5"></path>
  <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"></path>
  <path d="M8 16H3v5"></path>`,
  'search': `<path d="m21 21-4.34-4.34"></path>
  <circle cx="11" cy="11" r="8"></circle>`,
  'send': `<path d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z"></path>
  <path d="m21.854 2.147-10.94 10.939"></path>`,
  'settings': `<path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"></path>
  <circle cx="12" cy="12" r="3"></circle>`,
  'shield-check': `<path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
  <path d="m9 12 2 2 4-4"></path>`,
  'smartphone': `<rect width="14" height="20" x="5" y="2" rx="2" ry="2"></rect>
  <path d="M12 18h.01"></path>`,
  'sparkles': `<path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z"></path>
  <path d="M20 2v4"></path>
  <path d="M22 4h-4"></path>
  <circle cx="4" cy="20" r="2"></circle>`,
  'star': `<path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path>`,
  'tag': `<path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"></path>
  <circle cx="7.5" cy="7.5" r=".5" fill="currentColor"></circle>`,
  'ticket': `<path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"></path>
  <path d="M13 5v2"></path>
  <path d="M13 17v2"></path>
  <path d="M13 11v2"></path>`,
  'timer': `<line x1="10" x2="14" y1="2" y2="2"></line>
  <line x1="12" x2="15" y1="14" y2="11"></line>
  <circle cx="12" cy="14" r="8"></circle>`,
  'triangle-alert': `<path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"></path>
  <path d="M12 9v4"></path>
  <path d="M12 17h.01"></path>`,
  'user': `<path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
  <circle cx="12" cy="7" r="4"></circle>`,
  'users': `<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
  <path d="M16 3.128a4 4 0 0 1 0 7.744"></path>
  <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
  <circle cx="9" cy="7" r="4"></circle>`,
  'x': `<path d="M18 6 6 18"></path>
  <path d="m6 6 12 12"></path>`,
  'zap': `<path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"></path>`,
} as const

export type IconName = keyof typeof ICONS
